import { TwinDictionary } from '../globals/dictionary'
import useTwinTranslation from './useTwinTranslation'

const useDictMonths = () => {
    const { t } = useTwinTranslation()
    const dictMonths: TwinDictionary = {
        1: t('january', 'Enero'),
        2: t('february', 'Febrero'),
        3: t('march', 'Marzo'),
        4: t('april', 'Abril'),
        5: t('may', 'Mayo'),
        6: t('june', 'Junio'),
        7: t('july', 'Julio'),
        8: t('august', 'Agosto'),
        9: t('september', 'Septiembre'),
        10: t('october', 'Octubre'),
        11: t('november', 'Noviembre'),
        12: t('december', 'Diciembre')
    }
    const arrMonthShort = [
        t('gen', 'En'), t('feb', 'Feb'), t('mar', 'Mar'), t('apr', 'Abr'), t('may', 'Mayo'), t('jun', 'Jun'),
        t('jul', 'Jul'), t('aug', 'Ag'), t('sep', 'Sep'), t('oct', 'Oct'), t('nov', 'Nov'), t('dec', 'Dic')
    ]
    return { dictMonths, arrMonthShort }
}

export default useDictMonths